import "./testimonials.css";
import { Autoplay, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { urlFor } from "../../sanityClient";

const Testimonials = ({ test }) => {
  return (
    <section id="testimonials" className="bg-alt p-12">
      <h2
        className="text-2xl  leading-none text-center md:text-[32px]   font-bold 
      "
      >
        {test.sectionTitle}
      </h2>
      <Swiper
        modules={[Pagination, Autoplay]} // 👈 add it here
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
        autoplay={{
          delay: 3000, // 3 seconds between slides
          disableOnInteraction: false, // keeps autoplay even when user swipes
        }}
        loop={true} // 👈 makes it infinite
        className="container testimonials__container"
      >
        {test.items.map(({ _key, name, review, image }) => {
          return (
            <SwiperSlide key={_key} className="testimonial">
              <div className="client__avatar">
                <img src={urlFor(image).url()} alt={`${name}'s avatar`} />
              </div>
              <h5 className="client__name text-2xl">{name}</h5>
              <p className="client__review">{review}</p>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Testimonials;
